Ext.define('SA.BarChartConfig', {
    singleton: true,

    aliasedLocationFontColor: '#aaa',
    axisTitleFontColor: '#2c3852',
    axisTitleFontSize: '14px',
    axisTitleLineHeight: 1.3,
    axisTitleMargin: 32,
    barFill: '#80bbff',
    barFontColor: '#727a8b',
    barFontSize: '11px',
    barMaxWidth: 108,
    barMinWidth: 54,
    barGutterWidth: 16,
    barStrokeColor: '#57a5ff',
    fontFamily: 'LatoLatinWeb, Lato', 
    fontVariant: 'no-common-ligatures', 
    innerGridLineColor: '#ddd',
    marginBottom: 30,
    marginLeft: 60,
    marginRight: 60,
    marginTop: 60,
    outerGridLineColor: '#aaafb9',
    xAxisFontColor: '#2c3852',
    xAxisFontSize: '13px',
    xAxisLabelLineHeight: 15,
    xAxisLabelMaxWidth: 160,
    yAxisFontColor: '#727a8b',
    yAxisFontSize: '12px',
    yAxisLabelOffset: 6,
    yAxisMaxHeight: 575,
    yAxisMinHeight: 350,
    yAxisTickCount: 5
});